
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="svg-arrow" [ngClass]="'svg-arrow-' + orientation">
    <defs><style>.a,.b{fill:none;}.a{stroke:white;stroke-linejoin:round;stroke-width:2px;}</style></defs>
    <path class="a" [ngClass]="strokeColor" d="M71.109-2.215c6.113,0,8-7.1,8-7.1s2.381,7.1,8,7.1" transform="translate(94.609 10.187) rotate(180)"/>
    <rect class="b" width="32" height="32" transform="translate(32 32) rotate(180)"/>
</svg>